import React from "react";

import Banner from "../../../assets/images/backgrounds/banner-seguro-saude-empresarial-desktop.png";
import BannerMobile from "../../../assets/images/backgrounds/banner-seguro-saude-empresarial-mobile.png";
import HeroSection from "../../../components/Habitacional/HeroSection";

import { HealthInsuranceContent } from "../../../components/Saude/HealthInsuranceContent";

export const BusinessHealthInsurance = () => {
  return (
    <>
      <HeroSection
        backgroundImageDesktop={Banner}
        backgroundImageMobile={BannerMobile}
        primarySubtitle="Seguro"
        mainTitle="Saúde Empresarial"
      />
      <HealthInsuranceContent />
    </>
  );
};
